<template>
    <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div class="text-center">
            <p class="text-9xl font-semibold text-[#36a8dd] ">{{props.statusCode}}</p>
            <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">{{ props.message }}</h1>
            <p class="mt-6 text-base leading-7 text-gray-600">{{ messages[0] }}</p>
            <p class="text-base leading-7 text-gray-600">{{ messages[1] }}</p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
                <button @click="refresh();"
                    class="rounded-md bg-[#36a8dd] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#36a8dd] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#36a8dd] ">Refresh</button>
                    
            </div>
        </div>
    </main>
</template>

<script lang='ts' setup>
import { defineProps} from 'vue'

const props = defineProps(['message', 'statusCode'])
const messages = [
    "Sorry, something went wrong",
    "Try refresh the page or try again in a moment"
]

function refresh() {
    location.reload()
}

</script>